import { Component, OnInit } from '@angular/core';
import { LiturgyType, LiturgyTypeService } from '../../services/liturgy-type.service';
import { LectionaryItemType, LectionaryItemTypeService } from '../../services/lectionary-item-type.service';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/services/api.service';
import { LiturgyTypeLectionaryItemTypeDisplayOrder } from 'app/objects';
 

@Component({
  selector: 'app-liturgy-type-lectionary-item-type-display-order-edit',
  templateUrl: './liturgy-type-lectionary-item-type-display-order-edit.component.html',
  styleUrls: ['./liturgy-type-lectionary-item-type-display-order-edit.component.css']
})
export class LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent  extends EditEntityBaseClass implements OnInit {

  public liturgyTypes: LiturgyType[];
  public lectionaryItemTypes: LectionaryItemType[];
  public selectedLectionaryItemType: LectionaryItemType;  //For use when selecting the sub type
  public item: LiturgyTypeLectionaryItemTypeDisplayOrder;
  
  constructor(private lectionaryItemTypeService: LectionaryItemTypeService, 
    private liturgyTypeSvc: LiturgyTypeService,
    private apiSvc: ApiService,
    private dialog: MatDialogRef<LiturgyTypeLectionaryItemTypeDisplayOrderEditComponent>) {

    super();
     }

  ngOnInit() {
    this.getEntities();


  }

  public getEntities() {

    this.lectionaryItemTypeService.loadEntities().then(s=> {
      this.lectionaryItemTypes = s;
    }); 

    this.liturgyTypeSvc.loadEntites().then(s=> {
      this.liturgyTypes = s;
    }); 

  }

  public setNew() {
    this.item = new LiturgyTypeLectionaryItemTypeDisplayOrder;
    this.item.DisplayOrder = 1;
    this.item.LectionaryItemType = new LectionaryItemType();  
    this.item.LectionaryItemType.Id = null;
    this.item.LiturgyType = new LiturgyType();  
    this.item.LiturgyType.Id = null;

    console.log("Init item", this.item); 
  }

  public setModel(model: LiturgyTypeLectionaryItemTypeDisplayOrder) {
 
      this.setNew();

      this.item.Id = model.Id;
      this.item.DisplayOrder = model.DisplayOrder;
      this.item.LectionaryItemType = model.LectionaryItemType;
      this.item.LectionaryItemTypeSubType = model.LectionaryItemTypeSubType;
      this.item.LiturgyType = model.LiturgyType;

      this.selectedLectionaryItemType = this.item.LectionaryItemType;

      console.log("Model received", this.item); 
  }

  public save() {
    console.log("Save", this.item);

    var payload = {
      Id: this.item.Id,
      LiturgyTypeId: this.item.LiturgyType.Id,
      LectionaryItemTypeId: this.item.LectionaryItemType.Id,  
      LectionaryItemTypeSubTypeId: null,
      DisplayOrder: this.item.DisplayOrder
    }; 

    if (this.item.LectionaryItemTypeSubType != null) { 
      payload.LectionaryItemTypeSubTypeId = this.item.LectionaryItemTypeSubType.Id;
    }

    console.log("Saving payload", payload);

    if (payload.LectionaryItemTypeId == null) {
      alert("Please select a Lectionary Item Type");
      return;
    }

    if (payload.LiturgyTypeId == null) {
      alert("Please select a Liturgy Type");
      return;
    }
    
    this.apiSvc.post("api/LiturgyTypeLectionaryItemTypeDisplayOrder/save", payload).subscribe(
      () => {
         this.cancel();  //This just closes the modal after a sucessful request
      },
      (err) => {
        console.log("error", err); 
        alert(err);
      }
   );

  }

  public lectionaryItemTypeValueChanged(e: number) { 
    var match = this.lectionaryItemTypes.find((s)=> s.Id === e);
    this.selectedLectionaryItemType = match;
    console.log(this.selectedLectionaryItemType);
  }

  public lectionaryItemTypeSubTypeValueChanged(e: number) {
    var match = this.selectedLectionaryItemType.SubTypes.find((s)=> s.Id === e);
    this.item.LectionaryItemTypeSubType = match;
    console.log(match);
  }

  public cancel() {
    this.dialog.close();
  }

  public delete() {
    console.log("Delete", this.item);
  }

}
